import React from 'react';

const SelectControl = ({ name, value, className, options = [], disabled, onChange }) => {
    return (
        <select  
            className={className || 'form-control'} 
            name={name}
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}            
            disabled={disabled || false } 
            >
            <option value=""></option>
            {
                options && options.map(option => {  
                    return <option key={option.key} value={option.key}>{`${option.value}`}</option>
                })
            }
        </select>
    );
}

export default SelectControl;